export const labelText = (matches850, matches400) => ({
  fontFamily: 'Poppins !important',
  fontWeight: 600,
  fontSize: matches400 ? '16px' : '18px !important',
  color: '#666',
  paddingBottom: '5px',
});

export const TextFieldError = {
  '.MuiFormHelperText-contained': {
    margin: '0',
    fontFamily: 'Poppins !important',
  },
  width: '100%',
};

export const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  maxWidth: 600,
  bgcolor: 'background.paper',
  // border: "2px solid #000",
  boxShadow: 24,
  p: 4,
  borderRadius: '10px',
};

export const solicitButton = {
  padding: '10px 20px',
  border: 'none',
  fontFamily: 'poppins !important',
  fontSize: '16px',
  fontWeight: 400,
  width: '45%',
};

export const headStyle = (matches850, matches400) => ({
  fontFamily: 'Poppins !important',
  fontSize: matches400 ? '16px' : matches850 ? '24px' : '28px',
  fontWeight: 600,
  marginTop: '10px',
  marginBottom: '20px',
  color: '#666',
  display: 'flex',
  justifyContent: 'flex-start',
});
